export default __webpack_public_path__ + "static/media/function.ea68a629.svg";